/**** mgt.MarshType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'MarshType',
  title: 'Виды сообщений',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'title',
      title: 'Наименование',
      type: 'text',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    title: '',
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'transfer_id',
        field: 'id',
      },{
        title: 'transfer_name',
        field: 'title',
      }
    ],
    example: `1;Название`,
  },
  export: {
    fields: [
      {
        name: 'title',
        title: 'Наименование',
      },
    ],
  },
};

export default config;
